<div class="mb-3 grouped-multi-select-input">
  @if (label != null) {
    <label for="{{ id }}">{{ label }}</label>
  }
  @if (showRequired) {
    <span class="required-indicator">*</span>
  }
  @if (!isReadOnly) {
    <ng-select
      [items]="items"
      [multiple]="true"
      bindLabel="label"
      groupBy="group"
      [selectableGroup]="true"
      [selectableGroupAsModel]="false"
      [closeOnSelect]="false"
      bindValue="value"
      [formControl]="control"
      placeholder="Select secondary categories"
      >
    </ng-select>
  } @else {
    <input readonly type="text" class="form-control" [value]="readOnlyData" />
  }
  @if (control.invalid) {
    <span class="help-block">
      <span class="required-indicator">
        {{ getErrorMessage() }}
      </span>
    </span>
  }
</div>
